module.exports = __webpack_public_path__ + "img/home-6-green.43ecb39d.png";